import Vue from "vue";
import Vuex, { GetterTree, ActionTree, MutationTree } from "vuex";
import { BreakpointListener } from "@/lib/tailwindBreakpoints";

import {tailwindBreakpoints} from "@/lib/tailwindBreakpoints";

Vue.use(Vuex);

const state = () => ({
  mqls: [] as MediaQueryList[],
  size: "default" as keyof BreakpointListener,
});

type MqlState = ReturnType<typeof state>;

const getters: GetterTree<MqlState, MqlState> = {
  active(state) {
    return state.size;
  },
};

const mutations: MutationTree<MqlState> = {
  SET_ACTIVE_SIZE: (state, size) => (state.size = size),
  SET_MQLS: (state, mqls) => (state.mqls = mqls),
};

const actions: ActionTree<MqlState, MqlState> = {
  initMqls({ dispatch, state }) {
    if (!state.mqls.length) {
      dispatch("setUpMqls");
    }
  },
  setUpMqls({ dispatch, commit }) {
    const { xs, sm, md, lg, xl, "2xl": xl2 } = tailwindBreakpoints;
    const mqls = [xs, sm, md, lg, xl, xl2].map((mq) =>
      matchMedia(`(min-width: ${mq})`)
    );

    commit("SET_MQLS", mqls);

    mqls.forEach((mql, i) => {
      mql.addEventListener("change", (_) => dispatch("onMqlChange", mqls));
    });
    dispatch("onMqlChange", mqls);
  },
  onMqlChange({ commit }, mqls: MediaQueryList[]) {
    const matching = mqls.filter((mql) => mql.matches).length;
    switch (matching - 1) {
      case 0:
        commit("SET_ACTIVE_SIZE", "xs");
        break;
      case 1:
        commit("SET_ACTIVE_SIZE", "sm");
        break;
      case 2:
        commit("SET_ACTIVE_SIZE", "md");
        break;
      case 3:
        commit("SET_ACTIVE_SIZE", "lg");
        break;
      case 4:
        commit("SET_ACTIVE_SIZE", "xl");
        break;
      case 5:
        commit("SET_ACTIVE_SIZE", "xl2");
        break;
      default:
        commit("SET_ACTIVE_SIZE", "default");
        break;
    }
  },
};

const rooState = {
  state,
  mutations,
  actions,
  getters,
};

export default new Vuex.Store(rooState);
